// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

/** Tracking impression context props */
export type TrackingImpressionContextProps = {|
  /** The id of the nearest impression. Will be undefined if there is no parent impression */
  impressionId?: string,
  /** Whether or not the nearest parent impression has been logged */
  isImpressionLogged?: boolean,
|};

/** Tracking impression provider props */
type TrackingImpressionProviderProps = {|
  /** All the context props */
  ...TrackingImpressionContextProps,
  /** Child nodes to render */
  children: React.Node,
|};

const defaultContext: TrackingImpressionContextProps = Object.freeze({});
/**
 * Tracking impression context.
 */
const TrackingImpression: React.Context<TrackingImpressionContextProps> = React.createContext(
  defaultContext,
);
const { Provider, Consumer } = TrackingImpression;

/** Tracking impression context provider */
const TrackingImpressionContextProvider = (props: TrackingImpressionProviderProps) => {
  const { children, ...providerValue } = props;
  return <Provider value={providerValue}>{children}</Provider>;
};
TrackingImpressionContextProvider.defaultProps = {
  impressionId: undefined,
  isImpressionLogged: false,
};

export {
  Consumer as TrackingImpressionContext,
  TrackingImpressionContextProvider,
  TrackingImpression,
};
